import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
  Avatar,
  Box,
  Button,
  IconButton,
  Typography,
  Snackbar,
  Slide,
  Alert,
  Menu,
  MenuItem,
} from "@mui/material";
import CustomModal from "../../../components/seller/listings/Modal";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link } from "react-router-dom";
import { capitalizeFirstLetter } from "../../../utils/Utils";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import axios from "axios";
import config from "../../../config";
import { connect } from "react-redux";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";

const headCellSx = {
  borderBottom: "1px solid #2a2a2a",
  color: "#777",
  fontSize: "12px",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  backgroundColor: "#111",
  py: 1.5,
};

const rowSx = {
  cursor: "pointer",
  transition: "0.2s",
  "& td": { borderBottom: "1px solid #1e1e1e", color: "#ccc" },
  "&:hover": { backgroundColor: "#1f1f1f", "& td": { color: "#FFC001" } },
};

const featuredRowSx = {
  ...rowSx,
  "& td": { borderBottom: "1px solid #2a2a2a", color: "#ccc" },
  backgroundColor: "rgba(255,192,1,0.04)",
};

const ListingTableHeadings = [
  "",
  "Name",
  "Category",
  "SubCategory",
  "Status",
  "Price",
  "Actions",
];

const ServiceList = ({
  seller,
  jwtToken,
  setServiceListings,
  serviceListings,
  handleUpdateStatus,
  setConfirmProp2,
  handleCloseActionModal,
  openActionModal,
  setOpenActionModal,
  handleOpenFeaturedModal,
}) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuData, setMenuData] = useState(null);
  const [confirmProp, setConfirmProp] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [modalText, setModalText] = useState("");
  const [deleteListId, setDeleteListId] = useState();
  const [processing, setProcessing] = useState(false);

  const [snackbarStates, setSnackbarStates] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const handleCloseDeleteModal = () => setOpenDeleteModal(false);

  const handleOpenDeleteModal = (id) => {
    setDeleteListId(id);
    setOpenDeleteModal(true);
  };

  const handleMenuClick = (event, data) => {
    setMenuAnchorEl(event.currentTarget);
    setMenuOpen(true);
    setMenuData(data);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setMenuOpen(false);
    setMenuData(null);
  };

  useEffect(() => {
    if (confirmProp) {
      const deleteListing = async () => {
        setProcessing(true);
        let deleteRequest;
        try {
          deleteRequest = await axios.delete(
            `${config.SERVER_URL}/api/v1/listing_services/${deleteListId}`,
            {
              headers: {
                Authorization: `Bearer ${jwtToken}`,
              },
            }
          );
          if (deleteRequest.status === 200) {
            setProcessing(false);
            setConfirmProp(false);
            setOpenDeleteModal(false);
            setSnackbarStates({
              open: true,
              message: "Listing deleted successfully",
              severity: "success",
            });
            setServiceListings(
              serviceListings.filter((item) => item.id !== deleteListId)
            );
          }
        } catch (error) {
          setProcessing(false);
          setConfirmProp(false);
          setOpenDeleteModal(false);
          setSnackbarStates({
            open: true,
            message: "Something went wrong",
            severity: "error",
          });
        }
      };

      deleteListing();
    }
  }, [confirmProp]);

  const handleMarkAsUnavailable = (data) => {
    handleUpdateStatus(data);
    setModalText("Are you sure you want to mark the service as unavailable?");
    setOpenActionModal(true);
    handleMenuClose();
  };

  const handleMarkAsActive = (data) => {
    handleUpdateStatus(data);
    setModalText("Are you sure you want to mark the service as active?");
    setOpenActionModal(true);
    handleMenuClose();
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarStates({ ...snackbarStates, open: false });
  };

  const handleFeaturedListing = async (data) => {
    handleMenuClose();
    handleOpenFeaturedModal(data);
  };

  return (
    <>
      <Snackbar
        transitionDuration={{ enter: 1000, exit: 2000 }}
        TransitionComponent={Slide}
        TransitionProps={{ enter: true, exit: false }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={snackbarStates.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          variant="filled"
          sx={{ width: "100%" }}
          severity={snackbarStates.severity}
        >
          {snackbarStates.message}
        </Alert>
      </Snackbar>
      <CustomModal
        title="Service Alert"
        content={modalText}
        openModal={openActionModal}
        closeModal={handleCloseActionModal}
        actionTitle={"Confirm"}
        setConfirmProp={setConfirmProp2}
        actionColor={"green"}
      />
      <CustomModal
        title="Delete Alert"
        content={
          "Are you sure you want to delete this service? This action is irreversible."
        }
        openModal={openDeleteModal}
        closeModal={handleCloseDeleteModal}
        actionTitle={"Delete"}
        setConfirmProp={setConfirmProp}
        actionColor={"red"}
      />
      <Box sx={{ backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "16px", overflow: "hidden" }}>
        {serviceListings && serviceListings.length > 0 ? (
          <Box sx={{ overflowX: "auto" }}>
            <Table sx={{ borderCollapse: "collapse" }}>
              <TableHead>
                <TableRow>
                  {ListingTableHeadings.map((item) => (
                    <TableCell key={item} align="center" sx={headCellSx}>
                      {item}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {serviceListings.map((item) => (
                  <TableRow
                    key={item.name}
                    sx={item.is_featured ? featuredRowSx : rowSx}
                  >
                    {item.media && item.media[0]?.url && (
                      <TableCell align="left" sx={{ width: 0, p: "8px 12px" }}>
                        <Avatar
                          alt={item.name}
                          src={item.media?.[0]?.url}
                          sx={{ width: 40, height: 40, borderRadius: "8px" }}
                        />
                      </TableCell>
                    )}
                    <TableCell align="center" sx={{ fontSize: "13px", width: "8%" }}>
                      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5 }}>
                        {item.name}
                        {item.is_featured === true && (
                          <WorkspacePremiumIcon sx={{ ml: 0.5, fontSize: 16, color: "#FFC001" }} />
                        )}
                      </Box>
                    </TableCell>
                    <TableCell align="center" sx={{ fontSize: "13px" }}>{item.service.name}</TableCell>
                    <TableCell align="center" sx={{ fontSize: "13px" }}>{item.sub_service.name}</TableCell>
                    <TableCell align="center" sx={{ fontSize: "13px" }}>
                      {item.status === "active" ? "Active" : "Un-Available"}
                    </TableCell>
                    <TableCell align="center" sx={{ fontSize: "13px", color: "#FFC001 !important", fontWeight: 700 }}>
                      ${item.price}
                    </TableCell>
                    <TableCell align="center">
                      <IconButton
                        component={Link}
                        to={`/seller/service/edit/${item.id}`}
                        sx={{ color: "#666", "&:hover": { color: "#FFC001", backgroundColor: "rgba(255,192,1,0.08)" } }}
                        size="small"
                      >
                        <BorderColorIcon sx={{ fontSize: 16 }} />
                      </IconButton>
                      <IconButton
                        onClick={() => handleOpenDeleteModal(item.id)}
                        sx={{ color: "#666", "&:hover": { color: "#ff4444", backgroundColor: "rgba(255,68,68,0.08)" } }}
                        size="small"
                      >
                        <DeleteIcon sx={{ fontSize: 16 }} />
                      </IconButton>
                      <IconButton
                        aria-controls={`menu-${item.id}`}
                        aria-haspopup="true"
                        onClick={(event) => handleMenuClick(event, item)}
                        sx={{ color: "#666", "&:hover": { color: "#FFC001", backgroundColor: "rgba(255,192,1,0.08)" } }}
                        size="small"
                      >
                        <MoreVertIcon sx={{ fontSize: 16 }} />
                      </IconButton>
                      <Menu
                        id={`menu-${item.id}`}
                        anchorEl={menuAnchorEl}
                        open={menuOpen && menuData?.id === item.id}
                        onClose={handleMenuClose}
                        PaperProps={{ sx: { backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "10px" } }}
                      >
                        {!processing && (
                          <>
                            <MenuItem
                              onClick={() => {
                                if (item.status !== "active") {
                                  handleMarkAsActive(item);
                                } else {
                                  handleMarkAsUnavailable(item);
                                }
                              }}
                              sx={{ fontSize: "13px", color: "#ccc", "&:hover": { color: "#FFC001" } }}
                            >
                              {item.status === "active"
                                ? "Mark as unavailable"
                                : "Mark as active"}
                            </MenuItem>
                            {!item.is_featured && item.status === "active" && (
                              <MenuItem
                                onClick={() => handleFeaturedListing(item)}
                                sx={{ fontSize: "13px", color: "#ccc", "&:hover": { color: "#FFC001" } }}
                              >
                                Add as Featured
                              </MenuItem>
                            )}
                          </>
                        )}
                      </Menu>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        ) : (
          <Box
            display="flex"
            alignItems="center"
            sx={{ py: 8 }}
            justifyContent="center"
            flexDirection="column"
            gap={2}
          >
            <Typography sx={{ fontSize: "14px", color: "#555" }}>
              You don't have any services yet.
            </Typography>
            <Button
              component={Link}
              to={"/seller/service/create"}
              sx={{ px: 3, py: 1, borderRadius: "10px", backgroundColor: "#FFC001", color: "#000", fontWeight: 800, fontSize: "13px", textTransform: "none", "&:hover": { backgroundColor: "#e6ac00" } }}
            >
              + Add Service
            </Button>
          </Box>
        )}
      </Box>
    </>
  );
};

const mapStateToProps = ({ Auth, Seller }) => ({
  jwtToken: Auth.jwtToken,
  user: Auth.user,
  seller: Seller.seller,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ServiceList);
